import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default new Router({
  routes: [
    {
      path: '/unit',
      name: 'unit',
      component: () => import('@/views/unit.vue'),
      meta: {
        title: '组件库',
      },
    },
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '',
      },
    },
    {
      path: '/updatePsw',
      name: 'updatePsw',
      component: () => import('@/views/login/update'),
      meta: {
        title: '',
      },
    },
    {
      path: '/roles',
      name: 'roles',
      component: () => import('@/views/login/roles'),
      meta: {
        title: '',
      },
    },
    {
      path: '/homeIndex',
      name: 'homeIndex',
      component: () => import('@/views/homepage/index.vue'),
      meta: {
        title: '首页',
      },
    },
  ],
});
